import { render, staticRenderFns } from "./AddinTags.vue?vue&type=template&id=3f73e028&lang=pug&"
import script from "./AddinTags.vue?vue&type=script&lang=ts&"
export * from "./AddinTags.vue?vue&type=script&lang=ts&"
import style0 from "./AddinTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports